import subListing from '@seo/schemas/subListing';
import breadcrumbSchema from '../schemas/breadcrumb';

const subGoalSchema = ({ goal = {}, subGoal = {}, description }) => {
  const graph = [];
  const subGoalLink = `${goal.permalink}/${subGoal.link}`;
  const breads = [
    {
      name: 'Home',
      url: 'https://unacademy.com'
    },
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goal.name,
      url: goal.permalink
    },
    {
      name: subGoal.name,
      url: subGoalLink
    }
  ];
  graph.push(breadcrumbSchema(breads));
  graph.push(
    subListing({
      topic: goal.name,
      forPlus: true,
      name: `${goal.name} ${subGoal.name}`,
      description,
      link: subGoalLink
    })
  );
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};

export default subGoalSchema;
